<div appTheme *ngIf="firmwareManager.firmwareUpgradeProgressNotification !== null && firmwareManager.infoText == null"
    class="modal-box scrolling">
    <div class="mail-center-upgrade-firmware-container modal-box-frame">
        <i class="fa fa-cog fa-spin fa-4x"></i>
        <div class="mail-center-upgrade-firmware-text">
            <div>Upgrading : {{firmwareManager.firmwareUpgradeProgressNotification.DeviceDescription}}</div>
            <div *ngIf="!hasPercentCompleteReached100Percent">
                Completed : {{firmwareManager.firmwareUpgradeProgressNotification.PercentComplete}}%
            </div>
            <div *ngIf="hasPercentCompleteReached100Percent">{{finishingUpMessage}}</div>
        </div>

        <button *ngIf="!isUpgradeComplete" id="exitBtn" class="delete-button button-medium"
            (click)="showCancelFirmwareUpgradeConfirmation()">Exit Upgrade</button>
        <button *ngIf="isUpgradeComplete" id="doneBtn" class="delete-button button-medium"
            (click)="onDismissDialog()">Done</button>
    </div>

</div>